Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _ErrorMessage = require('../exp/ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _Label = require('../exp/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Link = require('../exp/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Text = require('../exp/Text');

var _Text2 = _interopRequireDefault(_Text);

var _Spacing = require('../exp/Spacing');

var _Spacing2 = _interopRequireDefault(_Spacing);

var _mutuallyExclusiveRequired = require('../utils/propTypes/mutuallyExclusiveRequired');

var _mutuallyExclusiveRequired2 = _interopRequireDefault(_mutuallyExclusiveRequired);

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _componentWithNamesOfHOCs = require('../utils/propTypes/componentWithNamesOfHOCs');

var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _visuallyHidden = require('../utils/visuallyHidden');

var _visuallyHidden2 = _interopRequireDefault(_visuallyHidden);

var _withStyles = require('../themes/withStyles');

var _mutuallyInclusive = require('../utils/propTypes/mutuallyInclusive');

var _mutuallyInclusive2 = _interopRequireDefault(_mutuallyInclusive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var exportedPropTypes = Object.assign({
  actionLink: (0, _componentWithNamesOfHOCs2['default'])(_Link2['default']),
  errorMessage: _textlike2['default'],
  hideLabel: _propTypes2['default'].bool,
  id: _idProp2['default'].isRequired,
  inline: _propTypes2['default'].bool,
  invalid: _propTypes2['default'].bool
}, (0, _mutuallyExclusiveRequired2['default'])({
  label: _textlike2['default'],
  hasExternalLabel: _propTypes2['default'].bool
}), {
  inverse: _propTypes2['default'].bool,
  labelDescription: _textlike2['default'],
  lightLabel: _propTypes2['default'].bool,
  small: _propTypes2['default'].bool,
  large: _propTypes2['default'].bool
});

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, exportedPropTypes, (0, _mutuallyInclusive2['default'])({
  errorMessage: _textlike2['default'],
  errorMessageID: _idProp2['default']
}), {
  children: _propTypes2['default'].node
}));

var defaultProps = {
  actionLink: null,
  errorMessage: null,
  hideLabel: false,
  inline: false,
  invalid: false,
  inverse: false,
  labelDescription: '',
  lightLabel: false, // design should follow up on if we want to keep this override ability
  small: false,
  large: false
};

function FormElement(_ref) {
  var css = _ref.css,
      actionLink = _ref.actionLink,
      children = _ref.children,
      hideLabel = _ref.hideLabel,
      errorMessage = _ref.errorMessage,
      errorMessageID = _ref.errorMessageID,
      id = _ref.id,
      inline = _ref.inline,
      invalid = _ref.invalid,
      inverse = _ref.inverse,
      label = _ref.label,
      labelDescription = _ref.labelDescription,
      hasExternalLabel = _ref.hasExternalLabel,
      lightLabel = _ref.lightLabel,
      small = _ref.small,
      large = _ref.large,
      styles = _ref.styles;

  var showErrorMessage = errorMessage && invalid;

  return _react2['default'].createElement(
    'div',
    css(styles.container, !inline && styles.block),
    !hasExternalLabel && !hideLabel && _react2['default'].createElement(
      _Spacing2['default'],
      { bottom: 1 },
      _react2['default'].createElement(
        _Label2['default'],
        { htmlFor: id },
        _react2['default'].createElement(
          _Text2['default'],
          { large: large, small: small, light: lightLabel && !small, inverse: inverse },
          label
        )
      ),
      (labelDescription || actionLink) && _react2['default'].createElement(
        _Text2['default'],
        {
          small: !small && !large,
          micro: small,
          light: true,
          inverse: inverse,
          inline: small
        },
        labelDescription,
        labelDescription && actionLink && ' ',
        actionLink
      )
    ),
    !hasExternalLabel && hideLabel && // eslint-disable-next-line jsx-a11y/label-has-for
    _react2['default'].createElement(
      'label',
      _extends({}, css(styles.label_hidden), { htmlFor: id }),
      label
    ),
    children,
    showErrorMessage && _react2['default'].createElement(
      _ErrorMessage2['default'],
      { id: errorMessageID, small: small },
      errorMessage
    )
  );
}

FormElement.componentCategory = 'Private';
FormElement.displayName = 'FormElement';
FormElement.propTypes = propTypes;

FormElement.defaultProps = Object.assign({}, defaultProps, {
  children: null
});

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    container: {
      display: 'inline-block'
    },

    block: {
      display: 'block',
      width: '100%'
    },

    label_hidden: Object.assign({}, _visuallyHidden2['default'])
  };
})(FormElement);
exports.propTypes = exportedPropTypes;
exports.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/FormElement.js
// module id = 429
// module chunks = 923280921217